export const environment = {
  production: false,
  apiBaseUrl: 'https://apiagora.codelabx.work',
  keycloakUrl: 'https://keycloak.codelabx.work',
  keycloakRealm: 'agora',
  defaultKeycloakClientId: 'agora-frontend-admin'
};
